import React from 'react';
import { Grid, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '../../../../core/Icon';
import { useDashboardState, useDashboardDispatch, save } from './context/dashboardContext';
import { useDesignImdbState, useDesignImdbDispatch, refreshImdb } from '../../Preview/DashboardPreview/designImdbContext';
import Utils from '../../../../utils';
var useStyles = makeStyles(function (theme) {
  return {
    divider: {
      height: 24,
      backgroundColor: 'rgba(255, 255, 255, 0.6)',
      margin: theme.spacing(1)
    }
  };
}, {
  name: 'ECToolbarCenterButtons'
});

var ToolbarCenterButtons = function ToolbarCenterButtons(_ref) {
  var path = _ref.path,
      workspace = _ref.workspace;
  var classes = useStyles();
  var dashboardState = useDashboardState();
  var dashboardDispatch = useDashboardDispatch();
  var designImdbState = useDesignImdbState();
  var designImdbDispatch = useDesignImdbDispatch();
  var canSave = dashboardState.editorState.serverContent !== dashboardState.content;
  var imdbLoading = designImdbState.stage === 'Starting' || designImdbState.stage === 'Processing';
  var edmPath = dashboardState.content && Utils.path.absolute(dashboardState.content.dashboard.dtLocalDataModel.dtDiagramDatasource.src, Utils.path.getFolderPath(path));
  return React.createElement(Grid, {
    container: true,
    alignItems: "center"
  }, React.createElement(Icon, {
    type: "save",
    disabled: !canSave || dashboardState.editorState.isSaving,
    onClick: function onClick() {
      dashboardDispatch({
        type: 'document_saving'
      }), save(dashboardDispatch, workspace, path, dashboardState.content);
    }
  }), React.createElement(Icon, {
    type: "undo",
    onClick: function onClick() {
      return dashboardDispatch({
        type: 'undo'
      });
    },
    disabled: dashboardState.undoStates.length === 0
  }), React.createElement(Icon, {
    type: "redo",
    onClick: function onClick() {
      return dashboardDispatch({
        type: 'redo'
      });
    },
    disabled: dashboardState.redoStates.length === 0
  }), React.createElement(Divider, {
    orientation: "vertical",
    classes: {
      root: classes.divider
    }
  }), React.createElement(Icon, {
    type: "refresh",
    label: imdbLoading ? 'Refreshing...' : 'Refresh',
    labelPlacement: "end",
    onClick: function onClick() {
      return refreshImdb(designImdbDispatch, workspace, edmPath);
    },
    disabled: imdbLoading
  }));
};

export default ToolbarCenterButtons;